import { styled } from '@/src/stitches.config'
import { amberA, greenA, redA } from '@radix-ui/colors'

interface AlertProps {
    variant: 'error' | 'success' | 'warning' | 'discount'
    label: string
    onClick?: () => void
    testId?: string
    css?: object
    size?: 'sm' | 'md' | 'lg'
}

const StyledAlert = styled('div', {
    color: '$error',
    padding: '$2',
    borderWidth: '2px',
    borderStyle: 'solid',
    borderRadius: '$2',
    variants: {
        variant: {
            error: {
                color: '$error',
                backgroundColor: redA.redA6,
                borderColor: '$error',
            },
            warning: {
                color: amberA.amberA11,
                backgroundColor: amberA.amberA6,
                borderColor: amberA.amberA11,
            },
            success: {
                color: '$success',
                backgroundColor: greenA.greenA6,
                borderColor: '$success',
            },
            discount: {
                color: '$primary',
                backgroundColor: '$primaryLight',
                borderColor: '$primaryLight',
                fontWeight: 'bold',
            },
        },
        size: {
            sm: {
                fontSize: '.75rem',
                padding: 5,
            },
            md: {
                fontSize: '1rem',
            },
            lg: {
                fontSize: '1.25rem',
            },
        },
    },
    defaultVariants: {
        size: 'md',
    },
})

export const Alert = ({
    variant,
    label,
    size,
    css = {},
    ...props
}: AlertProps) => {
    return (
        <StyledAlert
            data-testid={`${variant}-alert`}
            variant={variant}
            size={size}
            style={css}
            {...props}
        >
            {label}
        </StyledAlert>
    )
}
